<template>
  <section class="p-3 pt-6">
    <div class="shadow py-4 px-6 h-full rounded-lg">
      <h3 class="text-gray-dark font-bold text-md mb-3">Reviews</h3>
      <div>
        <section
          v-if="
            trainerReviews.data &&
            trainerReviews.data.own_review &&
            Object.keys(trainerReviews.data.own_review).length !== 0
          "
          class="ring-1 ring-gray-200 px-4 py-3 rounded"
        >
          <div v-if="!editReview">
            <div class="flex items-center justify-between">
              <div class="flex items-center">
                <Avatar
                  :src="
                    trainerReviews &&
                    trainerReviews.data &&
                    trainerReviews.data.own_review &&
                    baseUrlSrc(trainerReviews.data.own_review.thumbnail_url)
                  "
                  classStr="h-8 w-8"
                />
                <div class="ml-3">
                  <p class="text-gray-dark text-xl capitalize">
                    {{
                      trainerReviews.data &&
                      trainerReviews.data.own_review &&
                      trainerReviews.data.own_review.name
                    }}
                  </p>
                  <div class="mt-1">
                    <Rating
                      :data="
                        trainerReviews.data &&
                        trainerReviews.data.own_review &&
                        trainerReviews.data.own_review.rating
                      "
                    />
                  </div>
                </div>
              </div>
              <div class="relative" v-click-outside="handleOutside">
                <button type="button" @click="showDropDown = !showDropDown">
                  <DotsVertical />
                </button>
                <div
                  v-if="showDropDown"
                  class="origin-top-right absolute right-0 w-48 rounded-md shadow-lg z-10"
                >
                  <ul class="py-1 relative rounded-md bg-white shadow-xs">
                    <li
                      class="block px-4 py-2 text-sm leading-5 text-gray-700 w-full focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out text-left rounded cursor-pointer"
                      @click="EditReview(trainerReviews.data.own_review.id)"
                    >
                      Edit
                    </li>
                    <li
                      class="block px-4 py-2 text-sm leading-5 text-gray-700 w-full focus:outline-none focus:bg-gray-100 transition duration-150 ease-in-out text-left rounded cursor-pointer"
                      @click="DeleteReview(trainerReviews.data.own_review.id)"
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <p class="mt-4 text-gray-700 text-xs">
              {{
                trainerReviews.data &&
                trainerReviews.data.own_review &&
                trainerReviews.data.own_review.body
              }}
            </p>
            <div class="flex items-center mt-2">
              <div
                v-if="
                  trainerReviews &&
                  trainerReviews.data &&
                  trainerReviews.data.own_review &&
                  trainerReviews.data.own_review.is_liked
                "
                class="flex justify-center"
              >
                <button
                  type="button"
                  class="text-xs text-gray-dark focus:outline-none"
                  @click="handleReviewId(trainerReviews.data.own_review.id)"
                >
                  <HeartFill />
                </button>
              </div>
              <div v-else class="flex justify-center">
                <button
                  type="button"
                  class="text-xs text-gray-dark focus:outline-none"
                  @click="handleReviewId(trainerReviews.data.own_review.id)"
                >
                  <Heart />
                </button>
              </div>
              <p class="ml-1 text-xs text-gray-dark">
                {{
                  trainerReviews.data &&
                  trainerReviews.data.own_review &&
                  trainerReviews.data.own_review.like_counter
                }}
              </p>
              <span class="text-xs text-gray-800 ml-1"
                >People found this helpful</span
              >
            </div>
          </div>
        </section>
        <div v-else>
          <div v-if="getToken()">
            <TrainerReviewPost />
          </div>
        </div>
        <TrainerReviewPost
          v-if="editReview"
          :editReview="editReview"
          :review_id="review_id"
          :rating="
            trainerReviews.data &&
            trainerReviews.data.own_review &&
            trainerReviews.data.own_review.rating
          "
          :body="
            trainerReviews.data &&
            trainerReviews.data.own_review &&
            trainerReviews.data.own_review.body
          "
          @ReviewUpdated="editReview = false"
        />
        <div
          v-if="
            trainerReviews.data &&
            trainerReviews.data.others_reviews &&
            trainerReviews.data.others_reviews.data.length != 0
          "
        >
          <TrainerReviewList
            v-on:review_id="handleReviewId"
            :data="
              trainerReviews.data && trainerReviews.data.others_reviews.data
            "
          />
        </div>
        <div
          v-if="!trainerReviews.data && !loadingStatus"
          class="flex flex-col justify-center items-center text-xl text-gray-700 mt-8 space-y-8"
        >
          <img
            :src="require(`@/assets/img/my_sessions_no_data.svg`)"
            alt="..."
            class="w-72"
          />
          <div
            class="flex flex-col text-lg justify-center items-center text-center"
          >
            <span> Looks like it's empty.</span>
            <span>Be the first to give your feedback to the trainer.</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { Heart, HeartFill, DotsVertical } from "@/components/icons";
import { Avatar, Rating } from "@/components/t-components";
import TrainerReviewList from "@/components/TrainerReviewList";
import TrainerReviewPost from "@/components/TrainerReviewPost";
import { mapGetters, mapActions } from "vuex";
import ClickOutside from "vue-click-outside";

export default {
  components: {
    Heart,
    HeartFill,
    Avatar,
    Rating,
    TrainerReviewList,
    TrainerReviewPost,
    DotsVertical,
  },
  data() {
    return {
      showDropDown: false,
      editReview: false,
      review_id: 0,
    };
  },
  computed: {
    ...mapGetters(["trainerReviews"]),

    loadingStatus() {
      return this.$store.getters.loadingStatus;
    },
  },
  methods: {
    ...mapActions([
      "getTrainerReviews",
      "userReviewLike",
      "deleteTrainerReview",
    ]),

    async handleReviewId(id) {
      const data = {
        review_id: id,
        review_type: 1, // for trainer
        is_liked: 1, // 0 for increase or 1 for decrease
      };
      await this.userReviewLike(data);
      await this.getTrainerReviews(this.$route.params.trainer_id);
    },

    async DeleteReview(id) {
      this.editReview = false;
      await this.deleteTrainerReview(id);
      await this.getTrainerReviews(this.$route.params.trainer_id);
    },

    async EditReview(id) {
      this.showDropDown = !this.showDropDown;
      this.editReview = true;
      this.review_id = id;
    },

    handleOutside() {
      this.showDropDown = false;
    },
  },
  directives: {
    ClickOutside,
  },
  async created() {
    await this.getTrainerReviews(this.$route.params.trainer_id);
  },
};
</script>